module.exports = __webpack_public_path__ + "static/media/help.83bf8127.svg";